export function share(title, text) {
    if (navigator.share) {
        navigator.share({
            title: title,
            text: text
        })
    } else if (chipsAppShare(title, text)) {
        // supported native share
    } else {
        copyText(text)
        window.location.href = `
            intent:#Intent;
            action=android.intent.action.SEND;
            type=text/plain;
            S.android.intent.extra.SUBJECT=${encodeURIComponent(title)};
            S.android.intent.extra.TEXT=${encodeURIComponent(text)};
            end
        `.replaceAll("\n", "")
            .replaceAll(" ", "")
    }
}

function chipsAppShare(title, text) {
    try {
        // eslint-disable-next-line no-undef
        chipsApp.share(title, text)
        return true
    } catch (e) {
        return false
    }
}

function copyText(text) {
    const textArea = document.createElement('textarea')
    textArea.value = text

    Object.assign(textArea.style, {position: 'fixed', top: 0})
    Object.assign(textArea, {contentEditable: true, readOnly: true})

    document.body.appendChild(textArea)
    textArea.focus()

    const range = document.createRange()
    range.selectNodeContents(textArea)

    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
    textArea.setSelectionRange(0, 999999)

    document.execCommand('copy')
    document.body.removeChild(textArea)
}
